(() => {
  const addBusinessDays = (start, count) => {
    const date = new Date(start);
    let added = 0;
    while (added < count) {
      date.setDate(date.getDate() + 1);
      const day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }
    return date;
  };

  const normalizePriceNote = (element) => {
    const productInfo = element.closest('product-info');
    if (!productInfo) return;

    const taxesIncluded = element.dataset.bpcTaxesIncluded === 'true';
    const taxLabel = element.dataset.bpcTaxLabel || '';

    productInfo.querySelectorAll('.product__tax').forEach((note) => {
      if (taxesIncluded && taxLabel) {
        note.textContent = taxLabel;
        note.hidden = false;
        note.style.removeProperty('display');
        return;
      }
      note.remove();
    });
  };

  const render = (root = document) => {
    root.querySelectorAll('[data-bpc-simple-delivery]').forEach((element) => {
      normalizePriceNote(element);
      if (element.dataset.bpcDatesReady === '1') return;

      element.dataset.bpcDatesReady = '1';
      const target = element.querySelector('[data-bpc-arrival-date]');
      if (!target) return;

      const min = Number(element.dataset.minBusinessDays || 7);
      const max = Number(element.dataset.maxBusinessDays || 15);
      const locale = document.documentElement.lang || 'en-US';
      const formatter = new Intl.DateTimeFormat(locale, { month: 'short', day: 'numeric' });
      const today = new Date();

      target.textContent = `${formatter.format(addBusinessDays(today, min))}–${formatter.format(addBusinessDays(today, max))}`;
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => render(), { once: true });
  else render();

  document.addEventListener('shopify:section:load', (event) => render(event.target));
})();
